var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"ehc-btn",class:_vm.btnClass,attrs:{"color":_vm.color,"dark":_vm.dark},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_vm._t("left"),_c('strong',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }